/*
==========================================
Custom main-product.liquid
==========================================
*/

// Call Wishlist app
const callWishList = (_variant_id) => {
  // alert("Call Wishlist");
};

//カート追加
const addVariantToCart = (
  _variant_id,
  _variant_current_qty,
  _variant_inventory_quantity,
  _button_elem
) => {
  _button_elem.setAttribute("disabled", true);
  const current_qty = Number(_variant_current_qty),
    inventory_qty = Number(_variant_inventory_quantity),
    form_qty = 1;

  // if(current_qty + form_qty > inventory_qty){
  //   alert("在庫がありません。");
  //   document.getElementById(`c-add-cart--${_variant_id}`).textContent = "SOLD OUT";
  //   document.getElementById(`c-add-cart--${_variant_id}`).classList.add("button--disabled");
  //   document.getElementById(`c-add-cart--${_variant_id}`).classList.remove("button--primary");
  //   document.getElementById(`c-add-cart--${_variant_id}`).setAttribute("disabled",true);
  // }else{
  let formData = {
    items: [
      {
        id: Number(_variant_id),
        quantity: form_qty,
      },
    ],
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      dataType: "json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data && typeof data.items === "undefined") {
        alert(window.languages.productFormOverStock);
      } else {
        // ポップアップ通知
        const productInfo = data.items[0];
        console.log(productInfo);
        document.getElementById("add-cart-announce--img").src =
          productInfo.featured_image ? productInfo.featured_image.url : "";
        document.getElementById("add-cart-announce--img").alt =
          productInfo.title;
        document.getElementById("add-cart-announce--text").innerHTML = `
          <p class="mini-cart__product-title">${productInfo.product_title}</p>
          ${
            productInfo.variant_title !== "Default title" &&
            productInfo.variant_title !== ""
              ? `<p class="mini-cart__product-variant-title">${productInfo.variant_title}</p>`
              : ""
          }
          <span class="text--strong">${window.languages.productFormAddedToCart}</span>
        `;
        document
          .querySelector(".c-add-cart-announce-dialog__wrapper")
          .classList.add("open");
        document.querySelector(
          ".c-add-cart-announce-dialog__wrapper"
        ).dataset.opening_timer = 0;
      }
      _button_elem.removeAttribute("disabled");
    })
    .catch((error) => {
      alert("エラーが発生しました。ページを再表示します。");
      _button_elem.removeAttribute("disabled");
      console.error("Error:", error);
      window.location.reload();
    });
  // }
};

// Back InStock アプリ呼び出し
const callBackInStock = (_variant_id) => {
  console.log("Call BIS");
  // BIS.popup.show({ variantId: _variant_id });
  SIPopover.show({ variantId: _variant_id });
};

//Variant選択時
//※option：1種類で実装
const selectedVariant = (e, _elem_type) => {
  const variant_id = e.target.dataset.variant_id,
    variant_current_qty = e.target.dataset.variant_current_qty,
    variant_inventory_quantity = e.target.dataset.variant_inventory_quantity,
    option_1 = e.target.dataset.option_1,
    option_2 = e.target.dataset.option_2,
    option_3 = e.target.dataset.option_3;

  if (option_1 !== "") {
    const selector_option1 = document.getElementById(option_1);
    selector_option1.click();
  }
  if (option_2 !== "") {
    const selector_option2 = document.getElementById(option_2);
    selector_option2.click();
  }
  if (option_3 !== "") {
    const selector_option3 = document.getElementById(option_3);
    selector_option3.click();
  }

  if (_elem_type === "purchase_btn") {
    addVariantToCart(
      variant_id,
      variant_current_qty,
      e.target.dataset.variant_inventory_quantity,
      e.target
    );
  } else if (_elem_type === "favorite_btn") {
    callWishList(variant_id);
  } else if (_elem_type === "call_BIS") {
    callBackInStock(variant_id);
  }
};

// 2024.1.4 Add start : 「.hb-tab__list」クラスのタブ切り替え処理
//  productテンプレートのliquidブロックに「.hb-tab__list」クラスのリスト要素があるが、JS機能がないため動作していない。
//  そのため、JSでタブ切り替え機能を実装する。
document.addEventListener("DOMContentLoaded", () => {
  // タブアイテムとタブコンテンツの取得
  const tabItems = document.querySelectorAll(".hb-tab__list");
  const tabContents = document.querySelectorAll(".hb-tab__block");

  // タブアイテムの数だけループ
  tabItems.forEach((tabItem, index) => {
    // タブアイテムにクリックイベントリスナーを追加
    tabItem.addEventListener("click", (event) => {
      const targetIndx = index;
      // タブアイテムの表示制御
      tabItems.forEach((tabItem) => {
        tabItem.classList.remove("hb-tab__list--open");
      });
      event.target.classList.add("hb-tab__list--open");

      // タブコンテンツの表示制御
      tabContents.forEach((tabContent, indexChild) => {
        if (indexChild !== targetIndx) {
          tabContent.classList.remove("hb-tab__block--open");
        } else {
          tabContent.classList.add("hb-tab__block--open");
        }
      });
    });
  });
});
